import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  yourColumnHeader: {
    id: 'dthTqA',
    description: 'CSV Column Header',
    defaultMessage: 'CSV Column Header',
  },
});
